import { memo } from "react";
import cx from "classnames";
import { useShallow } from "zustand/react/shallow";

import Box from "ds/components/Box";

import useMainNavigationStore from "./stores/useMainNavigationStore";
import { selectNavigationIsExpanded } from "./selectors/navigationState";
import { useMainNavigationInitialization } from "./hooks/useInitialization";
import useMainNavigationScrollDetection from "./hooks/useScrollDetection";
import MainNavigationHeader from "./components/layout/Header";
import MainNavigationPrimaryItems from "./components/layout/PrimaryItems";
import MainNavigationButtonExpand from "./components/layout/ButtonExpand";
import MainNavigationSecondaryItems from "./components/layout/SecondaryItems";
import MainNavigationGradient from "./components/layout/Gradient";
import styles from "./styles.module.css";

const MainNavigation = () => {
  const { isSidebarExpanded, mobileFullScreen } = useMainNavigationStore(
    useShallow((state) => ({
      isSidebarExpanded: selectNavigationIsExpanded(state),
      mobileFullScreen: state.mobileFullScreen,
    }))
  );

  const { scrollContainerRef, canScrollUp, canScrollDown } = useMainNavigationScrollDetection();

  useMainNavigationInitialization();

  return (
    <Box
      id="main-navigation"
      className={cx(styles.mainNavigation, {
        [styles.expanded]: isSidebarExpanded,
        [styles.mobileFullScreen]: mobileFullScreen,
      })}
      direction="column"
      fullWidth
    >
      <MainNavigationGradient />

      <MainNavigationHeader />

      <Box
        className={cx(styles.navigationBodyWrapper, {
          [styles.canScrollUp]: canScrollUp,
          [styles.canScrollDown]: canScrollDown,
        })}
        grow="1"
        relative
        zeroMinHeight
        fullWidth
      >
        <Box
          ref={scrollContainerRef}
          direction="column"
          className={styles.navigationBody}
          scrollable
          fullWidth
        >
          <MainNavigationPrimaryItems />
        </Box>
      </Box>

      <Box direction="column" gap="medium" shrink="0">
        {!isSidebarExpanded && <MainNavigationButtonExpand />}
        <MainNavigationSecondaryItems />
      </Box>
    </Box>
  );
};

export default memo(MainNavigation);
